import { gridSizeMdLg10, handleErrorForm, ROUTER_PATHS, useCustomStepper } from "@/shared";
import { StepperBoxScene } from "@/shared/components/ui";
import { useNavigate } from "react-router-dom";
import TabOtrosCargosPreventaPymes from "@/erp/sale/asesor/preventa/shared/component/Tabs/TabOtrosCargosPreventaPymes";
import TabDocumentosPreventaPymes from "../../shared/componente/tabs_formulario_preventa_pymes/TabDocumentosPreventa";
import TabResidenciaPreventaPymes from "../../shared/componente/tabs_formulario_preventa_pymes/TabResidenciaPreventaPymes";
import TabServicioPreventaPymes from "../../shared/componente/tabs_formulario_preventa_pymes/TabServicioPreventaPymes";
import { useState } from "react";
import TabInformacionPersonalPreventaPymes from "../../shared/componente/tabs_formulario_preventa_pymes/TabInformacionPersonalPreventaPymes";
import LoadPreventa from "@/erp/sale/asesor/preventa/shared/component/load_preventa/LoadPreventa";
import { Typography } from "@mui/material";
import { useFormPreventaPymes } from "../../shared/hook/useFormPreventaPymes";

const steps = [
  "Informacion",
  "Residencia",
  "Servicio",
  "Otros Cargos",
  "Documentos",
];


export default function CreateProspectoPreventaPyemesPage() {

  const navigate = useNavigate()

  const [editSupervisor] = useState(false)

  /* const formPreventa = useFormProspectoPreventaPymes({
    editSupervisor: false
  }); */

  const formPreventa = useFormPreventaPymes({
    editSupervisor: false,
    prospectoResp: null
  });

  const {
    activeStep,
    handleBack,
    handleNext, disableNextStepBtn
  } = useCustomStepper({ steps: steps })


  return (
    <>


      <StepperBoxScene
        titlePage="Preventa - Prospecto"
        steps={steps}
        activeStep={activeStep}
        handleNext={handleNext}
        handleBack={handleBack}
        disableNextStepBtn={disableNextStepBtn}
        onCancel={() => {
          navigate(ROUTER_PATHS.ventasPymes.prospectoNav)
          formPreventa.form.reset({})
        }}
        onSave={formPreventa.form.handleSubmit((form) => {
          formPreventa.handleOnSubmit(form)
        }, (error) => {
          console.log(error);
          handleErrorForm(error)
        })}
        size={gridSizeMdLg10}
        py={0}
        additionalNoteText={
          <>
            {
              formPreventa.form.getValues().condicion_venta && (
                <Typography>Condición Venta: <b>{
                  formPreventa.form.getValues().condicion_venta
                }</b></Typography>
              )
            }
          </>
        }
      >



        {activeStep === 0 && (
          <TabInformacionPersonalPreventaPymes
            buscarProspecto={true}
            editSupervisor={editSupervisor}
            {...formPreventa!}
          />
        )}

        {activeStep === 1 && (
          <TabResidenciaPreventaPymes
            editSupervisor={editSupervisor}
            {...formPreventa}
          />
        )}
        {activeStep === 2 && (
          <TabServicioPreventaPymes
            editSupervisor={editSupervisor}
            {...formPreventa}
          />
        )}
        {activeStep === 3 && (
          <TabOtrosCargosPreventaPymes
            editSupervisor={editSupervisor}
            {...formPreventa}
          />
        )}

        {activeStep === 4 && (
          <TabDocumentosPreventaPymes
            editSupervisor={editSupervisor}
            {...formPreventa}
          />
        )}
      </StepperBoxScene>

      <LoadPreventa
        open={formPreventa.isPendingPreventa
          || formPreventa.isPendingUpdatePreventa}
      />

    </>
  )

}